<i18n>
{
    "ru": {
        "card": "Карта",
        "of_foreign_bank": "иностранного банка"
    },
    "en": {
        "card": "Card",
        "of_foreign_bank": "of foreign bank"
    }
}
</i18n>

<template>
  <div :class="$style.icons">
      <Logo />
      <span :class="$style.title">{{ $t("card") }}<br>{{ $t("of_foreign_bank") }}
      </span>
  </div>
</template>

<script>
import Logo from "../shapes/ForeignPayLogo";

export default {
  name: "SbpPaymentBlockIcons",
  components: {
    Logo
  }
};
</script>

<style lang="postcss" module>
  .icons {
    display: flex;
    gap: 12px;
    margin-top: 0;
    align-items: center;
  }

  .title {
    width: 141px;
    color: #000;
    font-family: 'museosanscyrl';
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }

  .icons > svg {
    height: 55px;
  }
</style>
